import { faSteam } from '@fortawesome/free-brands-svg-icons/faSteam'
import { faPlaystation } from '@fortawesome/free-brands-svg-icons/faPlaystation'
import { faItchIo } from '@fortawesome/free-brands-svg-icons/faItchIo'
import { faApple } from '@fortawesome/free-brands-svg-icons/faApple'
import { faAndroid } from '@fortawesome/free-brands-svg-icons/faAndroid'
import { faXbox } from '@fortawesome/free-brands-svg-icons/faXbox'
import icNintendoSwitch from 'root/src/client/public/icons/ic-nintendo-switch'
import icEpic from 'root/src/client/public/icons/ic-epic'
import icGog from 'root/src/client/public/icons/ic-gog'
import icOculus from 'root/src/client/public/icons/ic-oculus'
import icIndex from 'root/src/client/public/icons/ic-index'
import icVive from 'root/src/client/public/icons/ic-vive'

// TODO: replace with GiveawayRewardStatus
const dropKeyStatesEnum = {
	available: 'available',
	used: 'used',
}

const dropKeyPlatformEnum = {
	steam: 'steam',
	xbox: 'xbox',
	switch: 'switch',
	ps5: 'ps5',
	'itch.io': 'itch.io',
	ios: 'ios',
	android: 'android',
	playstationVR: 'playstationVR',
	oculusQuest: 'oculusQuest',
	oculusRift: 'oculusRift',
	epicGamesStore: 'epicGamesStore',
	ps4: 'ps4',
	xbox360: 'xbox360',
	xboxOne: 'xboxOne',
	gog: 'gog',
	index: 'index',
	vive: 'vive',
}

// TODO: replace with KeyType
const dropKeyTypesEnum = {
	betaKey: 'betaKey',
	earlyKey: 'earlyKey',
	completeEditionKey: 'completeEditionKey',
	retailType: 'retailKey',
	soundtrackKey: 'soundtrackKey',
	seasonPassKey: 'seasonPassKey',
	specialKey: 'specialKey',
}
const dropKeyPlatformRegionsMap = {
	[dropKeyPlatformEnum.steam]: {
		worldwide: 'worldwide',
		northAmerica: 'northAmerica',
		europe: 'europe',
		china: 'china',
		asia: 'asia',
		russia: 'russia',
		southAmerica: 'southAmerica',
		oceania: 'oceania',
		middleEast: 'middleEast',
		africa: 'africa',
		centralAmerica: 'centralAmerica',
	},
	[dropKeyPlatformEnum.xbox]: {
		worldwide: 'worldwide',
		china: 'china',
	},
	[dropKeyPlatformEnum.xbox360]: {
		worldwide: 'worldwide',
		china: 'china',
	},
	[dropKeyPlatformEnum.xboxOne]: {
		worldwide: 'worldwide',
		china: 'china',
	},
	[dropKeyPlatformEnum.switch]: {
		worldwide: 'worldwide',
		japan: 'japan',
		americas: 'americas',
		europe: 'europe',
		oceania: 'oceania',
		china: 'china',
	},
	[dropKeyPlatformEnum.ps5]: {
		worldwide: 'worldwide',
		americas: 'americas',
		europe: 'europe',
		europeAndAmericas: 'europeAndAmericas',
		china: 'china',
	},
	[dropKeyPlatformEnum.ps4]: {
		worldwide: 'worldwide',
		siea: 'northAmerica/SouthAmerica',
		siee: 'europe/Africa/MiddleEast/Oceania',
		china: 'china',
	},
	[dropKeyPlatformEnum['itch.io']]: {
		worldwide: 'worldwide',
	},
	[dropKeyPlatformEnum.playstationVR]: {
		worldwide: 'worldwide',
		northAmerican: 'northAmerican',
		latinAmerican: 'latinAmerican',
		europe: 'europe',
		middleEast: 'middleEast',
		asia: 'asia',
		china: 'china',
		japan: 'japan',
		korea: 'korea',
	},
	[dropKeyPlatformEnum.oculusQuest]: {
		worldwide: 'worldwide',
		australia: 'australia',
		austria: 'austria',
		belgium: 'belgium',
		canada: 'canada',
		denmark: 'denmark',
		finland: 'finland',
		france: 'france',
		germany: 'germany',
		iceland: 'iceland',
		ireland: 'ireland',
		italy: 'italy',
		japan: 'japan',
		netherlands: 'netherlands',
		newZealand: 'newZealand',
		norway: 'norway',
		poland: 'poland',
		spain: 'spain',
		sweden: 'sweden',
		switzerland: 'switzerland',
		taiwan: 'taiwan',
		greatBritain: 'greatBritain',
		unitedStates: 'unitedStates',
	},
	[dropKeyPlatformEnum.oculusRift]: {
		worldwide: 'worldwide',
		australia: 'australia',
		austria: 'austria',
		belgium: 'belgium',
		canada: 'canada',
		denmark: 'denmark',
		finland: 'finland',
		france: 'france',
		germany: 'germany',
		iceland: 'iceland',
		ireland: 'ireland',
		italy: 'italy',
		japan: 'japan',
		netherlands: 'netherlands',
		newZealand: 'newZealand',
		norway: 'norway',
		poland: 'poland',
		spain: 'spain',
		sweden: 'sweden',
		switzerland: 'switzerland',
		taiwan: 'taiwan',
		greatBritain: 'greatBritain',
		unitedStates: 'unitedStates',
	},
	[dropKeyPlatformEnum.ios]: {
		worldwide: 'worldwide',
		northAmerica: 'northAmerica',
		europe: 'europe',
		china: 'china',
		asia: 'asia',
		russia: 'russia',
		southAmerica: 'southAmerica',
		oceania: 'oceania',
		middleEast: 'middleEast',
		africa: 'africa',
		centralAmerica: 'centralAmerica',
	},
	[dropKeyPlatformEnum.android]: {
		worldwide: 'worldwide',
		northAmerica: 'northAmerica',
		europe: 'europe',
		china: 'china',
		asia: 'asia',
		russia: 'russia',
		southAmerica: 'southAmerica',
		oceania: 'oceania',
		middleEast: 'middleEast',
		africa: 'africa',
		centralAmerica: 'centralAmerica',
	},
	[dropKeyPlatformEnum.epicGamesStore]: {
		worldwide: 'worldwide',
	},
	[dropKeyPlatformEnum.gog]: {
		worldwide: 'worldwide',
	},
	[dropKeyPlatformEnum.index]: {
		worldwide: 'worldwide',
		northAmerica: 'northAmerica',
		europe: 'europe',
		china: 'china',
		asia: 'asia',
		russia: 'russia',
		southAmerica: 'southAmerica',
		oceania: 'oceania',
		middleEast: 'middleEast',
		africa: 'africa',
		centralAmerica: 'centralAmerica',
	},
	[dropKeyPlatformEnum.vive]: {
		worldwide: 'worldwide',
		northAmerica: 'northAmerica',
		europe: 'europe',
		china: 'china',
		asia: 'asia',
		russia: 'russia',
		southAmerica: 'southAmerica',
		oceania: 'oceania',
		middleEast: 'middleEast',
		africa: 'africa',
		centralAmerica: 'centralAmerica',
	},
}

const platformIconMap = {
	[dropKeyPlatformEnum.steam]: faSteam,
	[dropKeyPlatformEnum.epicGamesStore]: icEpic,
	[dropKeyPlatformEnum.ps4]: faPlaystation,
	[dropKeyPlatformEnum.ps5]: faPlaystation,
	[dropKeyPlatformEnum.playstationVR]: faPlaystation,
	[dropKeyPlatformEnum.switch]: icNintendoSwitch,
	[dropKeyPlatformEnum.xbox]: faXbox,
	[dropKeyPlatformEnum.xbox360]: faXbox,
	[dropKeyPlatformEnum.xboxOne]: faXbox,
	[dropKeyPlatformEnum.ios]: faApple,
	[dropKeyPlatformEnum.android]: faAndroid,
	[dropKeyPlatformEnum.oculusQuest]: icOculus,
	[dropKeyPlatformEnum.oculusRift]: icOculus,
	[dropKeyPlatformEnum.gog]: icGog,
	[dropKeyPlatformEnum['itch.io']]: faItchIo,
	[dropKeyPlatformEnum.index]: icIndex,
	[dropKeyPlatformEnum.vive]: icVive,
}

const readableKeyTypesMap = {
	[dropKeyTypesEnum.retailType]: 'Retail',
	[dropKeyTypesEnum.specialKey]: 'Special',
	[dropKeyTypesEnum.betaKey]: 'Beta',
	[dropKeyTypesEnum.completeEditionKey]: 'Complete Edition',
	[dropKeyTypesEnum.earlyKey]: 'Early Access',
	[dropKeyTypesEnum.soundtrackKey]: 'Soundtrack',
	[dropKeyTypesEnum.seasonPassKey]: 'Season Pass',
}

const readablePlatformsMap = {
	[dropKeyPlatformEnum.steam]: 'Steam',
	[dropKeyPlatformEnum.epicGamesStore]: 'Epic Games Store',
	[dropKeyPlatformEnum.playstationVR]: 'PlayStation VR',
	[dropKeyPlatformEnum.ps4]: 'PS4',
	[dropKeyPlatformEnum.ps5]: 'PS5',
	[dropKeyPlatformEnum.xbox]: 'Xbox Series X/S',
	[dropKeyPlatformEnum.xbox360]: 'Xbox 360',
	[dropKeyPlatformEnum.xboxOne]: 'Xbox One',
	[dropKeyPlatformEnum.switch]: 'Switch',
	[dropKeyPlatformEnum.android]: 'Android',
	[dropKeyPlatformEnum.ios]: 'iOS',
	[dropKeyPlatformEnum.gog]: 'GOG',
	[dropKeyPlatformEnum.oculusQuest]: 'Oculus Quest',
	[dropKeyPlatformEnum.oculusRift]: 'Oculus Rift',
	[dropKeyPlatformEnum['itch.io']]: 'itch.io',
	[dropKeyPlatformEnum.index]: 'Valve Index',
	[dropKeyPlatformEnum.vive]: 'Vive',
}

const platformStoreUrlMap = {
	[dropKeyPlatformEnum.steam]: 'store.steampowered.com',
	[dropKeyPlatformEnum.epicGamesStore]: 'store.epicgames.com',
	[dropKeyPlatformEnum.playstationVR]: 'store.playstation.com',
	[dropKeyPlatformEnum.ps4]: 'store.playstation.com',
	[dropKeyPlatformEnum.ps5]: 'store.playstation.com',
	[dropKeyPlatformEnum.xbox]: 'www.xbox.com/microsoft-store',
	[dropKeyPlatformEnum.xbox360]: 'marketplace.xbox.com/games/Xbox360Games',
	[dropKeyPlatformEnum.xboxOne]: 'www.xbox.com/microsoft-store',
	[dropKeyPlatformEnum.switch]: 'www.nintendo.com/store',
	[dropKeyPlatformEnum.android]: 'play.google.com',
	[dropKeyPlatformEnum.ios]: 'www.apple.com/app-store',
	[dropKeyPlatformEnum.gog]: 'www.gog.com',
	[dropKeyPlatformEnum.oculusQuest]: 'www.oculus.com/experiences/quest',
	[dropKeyPlatformEnum.oculusRift]: 'www.oculus.com/experiences/rift',
	[dropKeyPlatformEnum['itch.io']]: 'itch.io',
	[dropKeyPlatformEnum.index]: 'store.steampowered.com',
	[dropKeyPlatformEnum.vive]: 'www.vive.com',
}

const dropKeyPlatformRegionsOptionsMap = {
	[dropKeyPlatformEnum.steam]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.steam].worldwide,
			label: 'Worldwide',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.steam].europe,
			label: 'Europe',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.steam].northAmerica,
			label: 'North America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.steam].centralAmerica,
			label: 'Central America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.steam].southAmerica,
			label: 'South America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.steam].asia,
			label: 'Asia',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.steam].china,
			label: 'China',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.steam].africa,
			label: 'Africa',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.steam].middleEast,
			label: 'Middle East',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.steam].russia,
			label: 'Russia',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.steam].oceania,
			label: 'Oceania',
		},
	],
	[dropKeyPlatformEnum.xbox]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.xbox].worldwide,
			label: 'Worldwide',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.xbox].china,
			label: 'China',
		},
	],
	[dropKeyPlatformEnum.xbox360]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.xbox360].worldwide,
			label: 'Worldwide',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.xbox360].china,
			label: 'China',
		},
	],
	[dropKeyPlatformEnum.xboxOne]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.xboxOne].worldwide,
			label: 'Worldwide',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.xboxOne].china,
			label: 'China',
		},
	],
	[dropKeyPlatformEnum.switch]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.switch].worldwide,
			label: 'Worldwide',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.switch].americas,
			label: 'Americas',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.switch].japan,
			label: 'Japan',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.switch].europe,
			label: 'Europe',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.switch].oceania,
			label: 'Oceania',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.switch].china,
			label: 'China',
		},
	],
	[dropKeyPlatformEnum.ps5]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ps5].worldwide,
			label: 'Worldwide',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ps5].americas,
			label: 'Americas',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ps5].europe,
			label: 'Europe',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ps5].china,
			label: 'China',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ps5].europeAndAmericas,
			label: 'Europe and Americas',
		},
	],
	[dropKeyPlatformEnum.ps4]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ps4].worldwide,
			label: 'Worldwide',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ps4].siea,
			label: 'SIEA (North America and South America)',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ps4].siee,
			label: 'SIEE (Europe, Africa, Middle East and Oceania)',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ps4].china,
			label: 'China',
		},
	],
	[dropKeyPlatformEnum.ios]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ios].worldwide,
			label: 'Worldwide',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ios].europe,
			label: 'Europe',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ios].northAmerica,
			label: 'North America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ios].centralAmerica,
			label: 'Central America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ios].southAmerica,
			label: 'South America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ios].asia,
			label: 'Asia',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ios].china,
			label: 'China',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ios].africa,
			label: 'Africa',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ios].middleEast,
			label: 'Middle East',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ios].russia,
			label: 'Russia',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.ios].oceania,
			label: 'Oceania',
		},
	],
	[dropKeyPlatformEnum.android]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.android].worldwide,
			label: 'Worldwide',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.android].europe,
			label: 'Europe',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.android].northAmerica,
			label: 'North America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.android].centralAmerica,
			label: 'Central America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.android].southAmerica,
			label: 'South America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.android].asia,
			label: 'Asia',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.android].china,
			label: 'China',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.android].africa,
			label: 'Africa',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.android].middleEast,
			label: 'Middle East',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.android].russia,
			label: 'Russia',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.android].oceania,
			label: 'Oceania',
		},
	],
	[dropKeyPlatformEnum['itch.io']]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum['itch.io']].worldwide,
			label: 'Worldwide',
		},
	],
	[dropKeyPlatformEnum.playstationVR]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.playstationVR].worldwide,
			label: 'Worldwide',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.playstationVR].northAmerican,
			label: 'North America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.playstationVR].latinAmerican,
			label: 'Latin America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.playstationVR].europe,
			label: 'Europe',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.playstationVR].middleEast,
			label: 'Middle East',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.playstationVR].asia,
			label: 'Asia',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.playstationVR].china,
			label: 'China',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.playstationVR].japan,
			label: 'Japan',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.playstationVR].korea,
			label: 'Korea',
		},
	],
	[dropKeyPlatformEnum.oculusQuest]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].worldwide,
			label: 'Worldwide',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].africa,
			label: 'Africa',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].australia,
			label: 'Australia',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].austria,
			label: 'Austria',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].belgium,
			label: 'Belgium',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].canada,
			label: 'Canada',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].denmark,
			label: 'Denmark',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].finland,
			label: 'Finland',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].france,
			label: 'France',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].germany,
			label: 'Germany',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].iceland,
			label: 'Iceland',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].ireland,
			label: 'Ireland',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].italy,
			label: 'Italy',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].japan,
			label: 'Japan',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].netherlands,
			label: 'Netherlands',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].newZealand,
			label: 'New Zealand',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].norway,
			label: 'Norway',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].poland,
			label: 'Poland',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].spain,
			label: 'Spain',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].sweden,
			label: 'Sweden',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].switzerland,
			label: 'Switzerland',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].taiwan,
			label: 'Taiwan',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].greatBritain,
			label: 'Great Britain',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusQuest].unitedStates,
			label: 'United States',
		},
	],
	[dropKeyPlatformEnum.oculusRift]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].worldwide,
			label: 'Worldwide',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].africa,
			label: 'Africa',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].australia,
			label: 'Australia',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].austria,
			label: 'Austria',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].belgium,
			label: 'Belgium',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].canada,
			label: 'Canada',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].denmark,
			label: 'Denmark',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].finland,
			label: 'Finland',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].france,
			label: 'France',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].germany,
			label: 'Germany',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].iceland,
			label: 'Iceland',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].ireland,
			label: 'Ireland',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].italy,
			label: 'Italy',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].japan,
			label: 'Japan',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].netherlands,
			label: 'Netherlands',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].newZealand,
			label: 'New Zealand',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].norway,
			label: 'Norway',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].poland,
			label: 'Poland',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].spain,
			label: 'Spain',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].sweden,
			label: 'Sweden',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].switzerland,
			label: 'Switzerland',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].taiwan,
			label: 'Taiwan',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].greatBritain,
			label: 'Great Britain',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.oculusRift].unitedStates,
			label: 'United States',
		},
	],
	[dropKeyPlatformEnum.epicGamesStore]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.epicGamesStore].worldwide,
			label: 'Worldwide',
		},
	],
	[dropKeyPlatformEnum.gog]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.gog].worldwide,
			label: 'Worldwide',
		},
	],
	[dropKeyPlatformEnum.index]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.index].worldwide,
			label: 'Worldwide',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.index].europe,
			label: 'Europe',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.index].northAmerica,
			label: 'North America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.index].centralAmerica,
			label: 'Central America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.index].southAmerica,
			label: 'South America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.index].asia,
			label: 'Asia',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.index].china,
			label: 'China',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.index].africa,
			label: 'Africa',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.index].middleEast,
			label: 'Middle East',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.index].russia,
			label: 'Russia',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.index].oceania,
			label: 'Oceania',
		},
	],
	[dropKeyPlatformEnum.vive]: [
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.vive].worldwide,
			label: 'Worldwide',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.vive].europe,
			label: 'Europe',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.vive].northAmerica,
			label: 'North America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.vive].centralAmerica,
			label: 'Central America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.vive].southAmerica,
			label: 'South America',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.vive].asia,
			label: 'Asia',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.vive].china,
			label: 'China',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.vive].africa,
			label: 'Africa',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.vive].middleEast,
			label: 'Middle East',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.vive].russia,
			label: 'Russia',
		},
		{
			value: dropKeyPlatformRegionsMap[dropKeyPlatformEnum.vive].oceania,
			label: 'Oceania',
		},
	],
}

export {
	// enums
	dropKeyStatesEnum,
	dropKeyTypesEnum,
	dropKeyPlatformEnum,
	// maps
	dropKeyPlatformRegionsMap,
	dropKeyPlatformRegionsOptionsMap,
	platformIconMap,
	readableKeyTypesMap,
	readablePlatformsMap,
	platformStoreUrlMap,
}
